const MONTH = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "6301 A,B,,B,b" -> ["6301A","6301B","6301b"] (exact duplicates dropped, case kept); "1234, 1235" -> ["1234","1235"]
export function stickerNumbers(raw) {
  let base = "";
  const out = [];
  String(raw || "").split(/[,;\n]+/).map((x) => x.trim()).filter(Boolean).forEach((part) => {
    const m = part.match(/^(\d+)\s*-?\s*([A-Za-z]*)$/);
    if (m) { base = m[1]; out.push(`${m[1]}${m[2]}`); return; }
    if (/^[A-Za-z]{1,3}$/.test(part) && base) { out.push(`${base}${part}`); return; }
    if (/\d/.test(part)) out.push(part);
  });
  return [...new Set(out)];
}

const col = (data, re) => Object.keys(data).find((k) => re.test(k.trim()));

export function stickerInfo(data) {
  const sd = data[col(data, /^service\s*date$/i)] || "";
  const m = String(sd).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const months = Array.from({ length: 12 }, (_, i) => String(data[String(i + 1)] ?? "").trim() !== "");
  let next = "";
  if (m && months.some(Boolean)) {
    const start = Number(m[2]) - 1;
    for (let k = 1; k <= 12; k += 1) {
      const mi = (start + k) % 12;
      if (months[mi]) { next = `${MONTH[mi]} ${Number(m[1]) + Math.floor((start + k) / 12)}`; break; }
    }
  }
  return {
    numbers: stickerNumbers(data[col(data, /^sticker/i)]),
    service: m ? `${Number(m[2])}/${m[1]}` : "",
    next,
    tech: String(data[col(data, /^tech$/i)] || "").trim(),
  };
}
